"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const client_1 = require("@apollo/client");
const subscriptions_1 = require("@apollo/client/link/subscriptions");
const const_1 = require("@app/const");
const config_1 = require("@app/const/config");
const query_1 = __importDefault(require("@app/request/query"));
const util_1 = require("@app/util");
const calendar_1 = __importDefault(require("@app/util/calendar"));
const misc_1 = __importDefault(require("@app/util/misc"));
const onboarding_signal_1 = require("@app/util/onboarding-signal");
const graphql_ws_1 = require("graphql-ws");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const store_1 = __importDefault(require("../store"));
const connect_1 = __importDefault(require("./connect"));
/**
 * Order-independent identity of a list of positions, for „did these change" against a payload
 * that lists the same positions but need not list them in the same order. Sorted rather than
 * compared pairwise because getting that wrong would not show as a wrong list — it would
 * silently fire a reload on every workspace event forever.
 */
const positionsFingerprint = (positions) => positions
    .map(({ id, name, color }) => `${id}|${name}|${color}`)
    .sort()
    .join();
class Websockets extends react_1.default.Component {
    wsClient;
    processBatchUpdates;
    processReloads;
    processDisconnects;
    initSubscriptions;
    destructSubscriptions;
    logDisconnect;
    logReconnect;
    scheduleBatchReload;
    getSecondsFromLastWarningUpdate;
    setStateCustom;
    wsSubscriptions;
    wsClientSubscribedToWsId;
    constructor(props) {
        super(props);
        this.processBatchUpdates = this._processBatchUpdates.bind(this);
        this.processReloads = this._processReloads.bind(this);
        this.processDisconnects = this._processDisconnects.bind(this);
        this.initSubscriptions = this._initSubscriptions.bind(this);
        this.destructSubscriptions = this._destructSubscriptions.bind(this);
        this.logDisconnect = this._logDisconnect.bind(this);
        this.logReconnect = this._logReconnect.bind(this);
        this.scheduleBatchReload = this._scheduleBatchReload.bind(this);
        this.getSecondsFromLastWarningUpdate =
            this._getSecondsFromLastWarningUpdate.bind(this);
        this.state = {
            processUpdatesInterval: setInterval(this.processBatchUpdates, 1000),
            processReloadsInterval: setInterval(this.processReloads, 8500),
            processDisconnectsInterval: setInterval(this.processDisconnects, 7000),
            batchUpdatesShifts: [],
            batchUpdatesTimeOffs: [],
            batchUpdatesAvailabilities: [],
            batchUpdatesWarnings: [],
            batchUpdatesOffers: [],
            batchUpdatesEmployees: [],
            batchReloads: [],
            warningUpdatesLog: {},
            disconnectsLog: [],
        };
        this.setStateCustom = this._setStateCustom.bind(this);
        this.wsSubscriptions = [];
    }
    // our custom setState function that wraps default this.setState() in flushSync().
    // reason: React18+ does automatic state update batching, which potentially causes each state update to overwrite some other
    //         recent state update call. the flushSync disables the automatic state update batching.
    _setStateCustom(stateUpdateFn) {
        (0, react_dom_1.flushSync)(() => {
            this.setState(stateUpdateFn);
        });
    }
    _logDisconnect() {
        const newDisconnectLog = this.state.disconnectsLog;
        newDisconnectLog.push({
            reconnected: false,
            time: (0, moment_1.default)().clone(),
            downtime: 0,
        });
        this.setStateCustom((s) => Object.assign({}, s, { disconnectsLog: newDisconnectLog }));
    }
    _logReconnect() {
        const oldestUnreconnectedIdx = this.state.disconnectsLog.findIndex((d) => !d.reconnected);
        if (oldestUnreconnectedIdx !== -1) {
            const newDisconnectLog = this.state.disconnectsLog;
            newDisconnectLog[oldestUnreconnectedIdx].reconnected = true;
            newDisconnectLog[oldestUnreconnectedIdx].downtime = (0, moment_1.default)()
                .clone()
                .diff(newDisconnectLog[oldestUnreconnectedIdx].time);
            this.setStateCustom((s) => Object.assign({}, s, { disconnectsLog: newDisconnectLog }));
            // whatever happened while the socket was down produced no event, so the onboarding
            // checklist has to re-read rather than wait for the next change. Inside this branch
            // on purpose: it only runs for a real reconnect, never for the first connect.
            (0, onboarding_signal_1.signalOnboardingRelevantChange)();
        }
    }
    _processDisconnects() {
        const maxDisconnects = 13;
        const maxDisconnectDuration = 20000;
        // if we can't edit the calendar, don't watch the connection stability. it doesn't matter.
        if (!util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.CALENDAR))
            return;
        // forget disconnections older than 2 minutes
        this.setStateCustom((s) => Object.assign({}, s, {
            disconnectsLog: this.state.disconnectsLog.filter((d) => (0, moment_1.default)(d.time).isAfter((0, moment_1.default)().clone().add(-2, 'minutes'))),
        }));
        // count disconnects & long disconnects last minute
        const disconnectsLastMinute = this.state.disconnectsLog.filter((d) => (0, moment_1.default)(d.time).isAfter((0, moment_1.default)().clone().add(-1, 'minute')));
        const longDisconnectsLastMinute = disconnectsLastMinute.filter((d) => d.downtime > maxDisconnectDuration ||
            (!d.reconnected &&
                (0, moment_1.default)(d.time).isBefore((0, moment_1.default)()
                    .clone()
                    .add(-1 * maxDisconnectDuration, 'milliseconds'))));
        // if there were > maxDisconnects disconnects last minute, or one over maxDisconnectDuration milliseconds, display the notice
        if (disconnectsLastMinute.length > maxDisconnects ||
            longDisconnectsLastMinute.length > 1) {
            util_1.notification.warn({
                message: (0, util_1.t)('RELOAD_NOTICE_UNSTABLE_CONNECTION_1'), // + t('RELOAD_NOTICE_UNSTABLE_CONNECTION_2') + t('RELOAD_NOTICE_UNSTABLE_CONNECTION_3'),
                config: {
                    duration: -1,
                    id: 'connection',
                },
            });
            // and print it to the console
            const errorMessage = (this.props.me ? this.props.me.id + ' ' : '') +
                'Unstable connection! ' +
                disconnectsLastMinute.length.toString() +
                ' disconnects, ' +
                longDisconnectsLastMinute.length.toString() +
                ' long ones.';
            console.log(errorMessage);
        }
        else {
            util_1.notification.remove('connection');
        }
    }
    _getSecondsFromLastWarningUpdate(usrId) {
        if (this.state.warningUpdatesLog?.[usrId]) {
            return Math.floor(Date.now() / 1000) - this.state.warningUpdatesLog[usrId];
        }
        else {
            return 9999999;
        }
    }
    // returns true if newly obtained event s2 is identical to older event s1 from store
    _isEventIdentical(s2, s1) {
        let same = true;
        for (const prop in s2) {
            // treat 'period' prop differently (use moment.js to compare period.start and period.end)
            if (prop === 'period' &&
                s1.period.start &&
                s1.period.end &&
                s2.period.start &&
                s2.period.end) {
                if (!(0, moment_1.default)(s1.period.start).isSame(s2.period.start) ||
                    !(0, moment_1.default)(s1.period.end).isSame(s2.period.end)) {
                    same = false;
                    break;
                }
            }
            else if (['pauses', 'overTime'].includes(prop)) {
                // use misc.safeStringify to compare 'pauses' and 'overTime'
                if (misc_1.default.safeStringify(s1.pauses) !== misc_1.default.safeStringify(s2.pauses)) {
                    same = false;
                    break;
                }
                // treat 'warnings' prop differently (check if all the warnings from s2 are also in s1 and vice versa)
            }
            else if (prop === 'warnings') {
                if (s2.warnings && s2.warnings.length === 0 && !s1.warnings) {
                    break;
                }
                if ((s2.warnings && !s1.warnings) ||
                    (!s2.warnings && s1.warnings) ||
                    (s2.warnings && s1.warnings && s2.warnings.length !== s1.warnings.length)) {
                    same = false;
                    break;
                }
                else {
                    s2.warnings.map((w2) => {
                        if (!s1.warnings.find((w1) => w1.name === w2.name)) {
                            same = false;
                        }
                    });
                    s1.warnings.map((w1) => {
                        if (!s2.warnings.find((w2) => w2.name === w1.name)) {
                            same = false;
                        }
                    });
                    if (!same)
                        break;
                }
                // all the other props: just check if they're equal
            }
            else {
                if (s1[prop] !== s2[prop]) {
                    same = false;
                    break;
                }
            }
        }
        return same;
    }
    _scheduleBatchReload(reloadType, targets = undefined) {
        const newBatchReloads = [...this.state.batchReloads];
        if (!newBatchReloads.some((br) => br.reloadType === reloadType)) {
            // if state.batchReloads doesn't contain this reload type yet, we push it there
            newBatchReloads.push({ reloadType, targets });
            this.setStateCustom((s) => Object.assign({}, s, { batchReloads: newBatchReloads }));
        }
        else {
            // if state.batchReloads already contains this reload type ...
            if (targets) {
                // ... and if we have some 'targets' for the reload, we just extend the targets list of the scheduled batchReload that's already in state.batchReloads
                const updIdx = newBatchReloads.findIndex((br) => br.reloadType === reloadType);
                if (!newBatchReloads[updIdx].targets)
                    newBatchReloads[updIdx].targets = [];
                targets.forEach((t) => {
                    if (!newBatchReloads[updIdx].targets.includes(t)) {
                        newBatchReloads[updIdx].targets.push(t);
                    }
                });
                this.setStateCustom((s) => Object.assign({}, s, { batchReloads: newBatchReloads }));
            }
        }
    }
    _processReloads() {
        const { loadExternalEmployees, loadChangedShiftsCount, loadRoleStatsMulti } = this.props;
        const { calendar } = store_1.default.getState();
        // process batch reloads
        if (this.state.batchReloads?.length) {
            this.state.batchReloads.forEach((br) => {
                // reload 'external-employees'
                if (br.reloadType === 'external-employees') {
                    loadExternalEmployees({
                        loadForPeriod: calendar_1.default.getReloadPeriod(store_1.default.getState().calendar),
                    });
                }
                // reload 'changed-shifts-count'
                if (br.reloadType === 'changed-shifts-count') {
                    loadChangedShiftsCount();
                }
                // reload 'role-stats'
                if (br.reloadType === 'role-stats') {
                    if (calendar?.date)
                        loadRoleStatsMulti(calendar.date, br.targets);
                }
                // remove this type from state.batchReloads
                this.setStateCustom((s) => Object.assign({}, s, {
                    batchReloads: this.state.batchReloads.filter((obr) => obr.reloadType !== br.reloadType),
                }));
            });
        }
    }
    _processBatchUpdates() {
        const { setShifts, setTimeOffs, setAvailabilities, updateWarnings, setOffers, setEmployees, isPluginEnabled, loadEmployeeDetail, } = this.props;
        const { calendar, calendarFilters, employees } = store_1.default.getState();
        const stateUpdate = {};
        // collect the list of IDs of users who can be influenced by the updates (we'll need to update their RoleStats & Warnings)
        const relevantUserIds = [];
        const addRelevantUserId = (upd) => {
            const potentialUserIds = [
                upd.obj?.userId,
                upd.obj?.revision?.diff?.userId?.__old,
                upd.obj?.revision?.diff?.userId?.__new,
            ].filter(Boolean);
            potentialUserIds.forEach((puid) => {
                if (!relevantUserIds.includes(puid) &&
                    employees[puid] &&
                    !employees[puid].external) {
                    relevantUserIds.push(puid);
                }
            });
        };
        // batch-update shifts
        if (this.state.batchUpdatesShifts?.length) {
            const { shifts } = store_1.default.getState();
            // update types: deleted / updated / created
            const deleted = this.state.batchUpdatesShifts.filter((upd) => upd.type === 'deleted') || [];
            const created = this.state.batchUpdatesShifts.filter((upd) => upd.type === 'created') || [];
            const updated = this.state.batchUpdatesShifts.filter((upd) => upd.type === 'updated') || [];
            // add influenced users to 'relevantUserIds'
            this.state.batchUpdatesShifts.forEach((upd) => {
                addRelevantUserId(upd);
            });
            // only update if updated shift is different than what we already have in store.
            // we want to avoid updating the store too much, because it would trigger unnecessary calendar render()
            let skipUpdate = false;
            if (updated.length === 1 && !deleted.length && !created.length) {
                const inStoreShift = shifts.find((sf) => sf.id === updated[0].obj.id);
                if (inStoreShift && this._isEventIdentical(updated[0].obj, inStoreShift)) {
                    skipUpdate = true;
                }
            }
            // run the update
            if (!skipUpdate) {
                setShifts(
                // start with current store.shifts
                shifts
                    // filter out shifts that are supposed to be deleted
                    .filter((sf) => !deleted.find((upd) => upd.obj.id === sf.id))
                    // add shifts that are supposed to be created
                    .concat(created.map((upd) => upd.obj))
                    // modify shifts that are supposed to be updated
                    .map((sf) => {
                    const updatedSf = updated.find((upd) => upd.obj.id === sf.id);
                    if (updatedSf) {
                        return Object.assign({}, sf, updatedSf.obj);
                    }
                    else {
                        return sf;
                    }
                }));
            }
            // reload the number of changed shifts on WS
            this.scheduleBatchReload('changed-shifts-count');
            // reset the state.batchUpdatesShifts
            stateUpdate.batchUpdatesShifts = [];
        }
        // batch-update timeOffs
        if (this.state.batchUpdatesTimeOffs?.length) {
            const { timeOffs } = store_1.default.getState();
            // update types: deleted / updated / created
            const deleted = this.state.batchUpdatesTimeOffs.filter((upd) => upd.type === 'deleted') || [];
            const created = this.state.batchUpdatesTimeOffs.filter((upd) => upd.type === 'created') || [];
            const updated = this.state.batchUpdatesTimeOffs.filter((upd) => upd.type === 'updated') || [];
            // add influenced users to 'relevantUserIds'
            this.state.batchUpdatesTimeOffs.forEach((upd) => {
                addRelevantUserId(upd);
            });
            // only update if updated event is different than what we already have in store.
            // we want to avoid updating the store too much, because it would trigger unnecessary calendar render()
            let skipUpdate = false;
            if (updated.length === 1 && !deleted.length && !created.length) {
                const inStoreEvent = timeOffs.find((sf) => sf.id === updated[0].obj.id);
                if (inStoreEvent && this._isEventIdentical(updated[0].obj, inStoreEvent)) {
                    skipUpdate = true;
                }
            }
            // run the update
            if (!skipUpdate) {
                setTimeOffs(
                // start with current store.timeOffs
                timeOffs
                    // filter out events that are supposed to be deleted
                    .filter((sf) => !deleted.find((upd) => upd.obj.id === sf.id))
                    // add events that are supposed to be created
                    .concat(created.map((upd) => upd.obj))
                    // modify events that are supposed to be updated
                    .map((sf) => {
                    const updatedSf = updated.find((upd) => upd.obj.id === sf.id);
                    if (updatedSf) {
                        return updatedSf.obj;
                    }
                    else {
                        return sf;
                    }
                }));
            }
            // reset the state.batchUpdatesTimeOffs
            stateUpdate.batchUpdatesTimeOffs = [];
        }
        // batch-update warnings
        if (this.state.batchUpdatesWarnings?.length) {
            const { shifts, timeOffs } = store_1.default.getState();
            setShifts(shifts.map((sf) => {
                const updatedSf = this.state.batchUpdatesWarnings.find((upd) => upd.eventId === sf.id);
                if (updatedSf) {
                    return Object.assign({}, sf, { warnings: updatedSf.warnings });
                }
                else {
                    return sf;
                }
            }));
            setTimeOffs(timeOffs.map((sf) => {
                const updatedSf = this.state.batchUpdatesWarnings.find((upd) => upd.eventId === sf.id);
                if (updatedSf) {
                    return Object.assign({}, sf, { warnings: updatedSf.warnings });
                }
                else {
                    return sf;
                }
            }));
            // reset the state.batchUpdatesWarnings
            stateUpdate.batchUpdatesWarnings = [];
        }
        // batch-update availabilities
        if (this.state.batchUpdatesAvailabilities?.length) {
            const { availabilities } = store_1.default.getState();
            // update types: deleted / updated / created
            const deleted = this.state.batchUpdatesAvailabilities.filter((upd) => upd.type === 'deleted') || [];
            const created = this.state.batchUpdatesAvailabilities.filter((upd) => upd.type === 'created') || [];
            const updated = this.state.batchUpdatesAvailabilities.filter((upd) => upd.type === 'updated') || [];
            // only update if updated event is different than what we already have in store.
            // we want to avoid updating the store too much, because it would trigger unnecessary calendar render()
            let skipUpdate = false;
            if (updated.length === 1 && !deleted.length && !created.length) {
                const inStoreEvent = availabilities.find((sf) => sf.id === updated[0].obj.id);
                if (inStoreEvent && this._isEventIdentical(updated[0].obj, inStoreEvent)) {
                    skipUpdate = true;
                }
            }
            // run the update
            if (!skipUpdate) {
                setAvailabilities(
                // start with current store.availabilities
                availabilities
                    // filter out events that are supposed to be deleted
                    .filter((sf) => !deleted.find((upd) => upd.obj.id === sf.id))
                    // add events that are supposed to be created
                    .concat(created.map((upd) => upd.obj))
                    // modify events that are supposed to be updated
                    .map((sf) => {
                    const updatedSf = updated.find((upd) => upd.obj.id === sf.id);
                    if (updatedSf) {
                        return updatedSf.obj;
                    }
                    else {
                        return sf;
                    }
                }));
            }
            // reset the state.batchUpdatesAvailabilities
            stateUpdate.batchUpdatesAvailabilities = [];
        }
        // batch-update offers
        if (this.state.batchUpdatesOffers?.length) {
            const { offers } = store_1.default.getState();
            const newOffers = 
            // start with the original offers from the store
            offers
                // filter out the offers that were just resolved,
                .filter((con) => !this.state.batchUpdatesOffers.find((obj) => obj.status === 'resolved' && obj.id === con.id))
                // update the remaining with the data from the WSS updates,
                .map((con) => {
                const obj = this.state.batchUpdatesOffers.find((obj) => obj.id === con.id);
                if (obj) {
                    return Object.assign({}, con, obj);
                }
                else {
                    return con;
                }
            });
            // and add the new ones
            newOffers.push(...this.state.batchUpdatesOffers.filter((obj) => !offers.find((con) => con.id === obj.id)));
            setOffers(newOffers);
            // reset the state.batchUpdatesOffers
            stateUpdate.batchUpdatesOffers = [];
        }
        // batch-update employees
        if (this.state.batchUpdatesEmployees?.length) {
            const { employees, employeeDetail, calendar } = store_1.default.getState();
            const newEmps = Object.assign({}, employees);
            this.state.batchUpdatesEmployees.forEach((upd) => {
                if (upd.type === 'deleted') {
                    newEmps[upd.obj.id] = Object.assign({}, newEmps[upd.obj.id], {
                        external: true,
                    });
                }
                if (upd.type === 'updated') {
                    newEmps[upd.obj.id] = Object.assign({}, newEmps[upd.obj.id], upd.obj);
                }
                if (upd.type === 'created')
                    newEmps[upd.obj.id] = Object.assign({}, upd.obj);
                // if employee's terminateDate was set to some past timestamp, we'll mark the employee as external in store
                if (newEmps[upd.obj.id].terminateDate &&
                    (0, moment_1.default)(newEmps[upd.obj.id].terminateDate).isSameOrBefore((0, moment_1.default)())) {
                    newEmps[upd.obj.id].external = true;
                }
                // if employee was marked as hidden, we take them out of newEmployees array
                if (newEmps[upd.obj.id].hidden)
                    delete newEmps[upd.obj.id];
                // if employee's contracts were changed while calendar.roleStats are loaded for this employee, we need to reload their roleStats
                const isContractsChanged = upd.type === 'updated' &&
                    employees &&
                    Object.keys(employees).includes(upd.obj?.id) &&
                    misc_1.default.safeStringify(upd.obj.contracts) !==
                        misc_1.default.safeStringify(employees[upd.obj.id].contracts);
                if (isContractsChanged &&
                    calendar &&
                    calendar.date &&
                    calendar.roleStats &&
                    calendar.roleStats[upd.obj.id]) {
                    this.scheduleBatchReload('role-stats', [upd.obj.id]);
                }
                // if we have loaded employeeDetail for this employee, reload the employeeDetail
                if (employeeDetail?.id === upd.obj.id) {
                    loadEmployeeDetail({ user: upd.obj.id });
                }
            });
            setEmployees(newEmps);
            // reset the state.batchUpdatesEmployees
            stateUpdate.batchUpdatesEmployees = [];
        }
        // reload the calendar.roleStats because the planned work hours of some people probably changed
        if (calendar?.loadedPeriods?.length &&
            (this.state.batchUpdatesShifts?.length ||
                this.state.batchUpdatesTimeOffs?.length)) {
            this.scheduleBatchReload('role-stats', relevantUserIds.length ? relevantUserIds : undefined);
        }
        // tell BE to recompute the warnings and push warning updates
        // (compute the warnings only for relevant users and in relevant period)
        const warningsHidden = calendarFilters?.length &&
            calendarFilters.find((fil) => fil.hideWarnings === 'all' || fil.hideWarnings === true);
        if (!warningsHidden && isPluginEnabled('laborlaw')) {
            if (relevantUserIds.length) {
                const updateWarningsForRelevantUsers = () => {
                    let startPeriod = (0, moment_1.default)().startOf('day');
                    let endPeriod = (0, moment_1.default)().add(1, 'day').endOf('day').format();
                    if (calendar?.loadedPeriods?.length) {
                        endPeriod = (0, moment_1.default)(calendar.loadedPeriods.map((lp) => (0, moment_1.default)(lp.end).format()).sort()[calendar.loadedPeriods.length - 1]).format();
                        startPeriod = (0, moment_1.default)(calendar.loadedPeriods.map((lp) => (0, moment_1.default)(lp.start).format()).sort()[0]).format();
                    }
                    // call the updates one after another, not on parallel (too many warning compoutation requests at once are terrible for the BE)
                    for (let i = 0; i < relevantUserIds.length; i++) {
                        const usrId = relevantUserIds[i];
                        if (relevantUserIds.length >= 2 &&
                            this.getSecondsFromLastWarningUpdate(usrId) < 180) {
                            // if this is a batch update (more than 1 shift), avoid calling
                            // for warnings update if we recently did that for this user
                        }
                        else {
                            const upd = {};
                            upd[usrId] = Math.floor(Date.now() / 1000);
                            stateUpdate.warningUpdatesLog = Object.assign({}, this.state.warningUpdatesLog, upd);
                            updateWarnings({
                                period: {
                                    start: startPeriod,
                                    end: endPeriod,
                                },
                                user: usrId,
                            });
                        }
                    }
                };
                updateWarningsForRelevantUsers();
            }
        }
        // actually update the state
        if (misc_1.default.safeStringify(stateUpdate) !== misc_1.default.safeStringify({})) {
            this.setStateCustom((s) => Object.assign({}, s, stateUpdate));
        }
    }
    _employeeHasChanged(originalEmpObj, currentEmpObj) {
        const orig = Object.assign({}, originalEmpObj, {
            lastSeen: undefined,
            lastMobileAppUse: undefined,
        });
        const curr = Object.assign({}, currentEmpObj, {
            lastSeen: undefined,
            lastMobileAppUse: undefined,
        });
        return (misc_1.default.safeStringify(Object.assign({}, orig, curr)) !==
            misc_1.default.safeStringify(orig));
    }
    async _addEmployeeUpdateToBatch(updateObj) {
        const newBatchUpdateEmps = this.state.batchUpdatesEmployees.some((bu) => bu.obj.id === updateObj.obj.id && bu.type === updateObj.type)
            ? this.state.batchUpdatesEmployees.map((bu) => {
                if (bu.obj.id === updateObj.obj.id && bu.type === updateObj.type) {
                    const ret = Object.assign({}, bu);
                    for (const key in updateObj.obj) {
                        ret.obj[key] = updateObj.obj[key];
                    }
                    return ret;
                }
                else {
                    return bu;
                }
            })
            : this.state.batchUpdatesEmployees.concat([updateObj]);
        this.setStateCustom((s) => Object.assign({}, s, {
            batchUpdatesEmployees: newBatchUpdateEmps,
        }));
    }
    _initSubscriptions() {
        const { auth, workspaceId, workspaces, me } = this.props;
        const { location: { hostname }, } = window;
        const { wsBackend } = (0, config_1.getEndpoints)(hostname);
        // initialize the websocket subscriptions
        if (auth &&
            workspaceId &&
            workspaces.some((ws) => ws.id === workspaceId) &&
            me &&
            me.id &&
            (!this.wsClient || this.wsClientSubscribedToWsId !== workspaceId)) {
            // unsubscribe all the previous subscriptions
            if (Array.isArray(this.wsSubscriptions)) {
                this.wsSubscriptions.forEach((subscription) => {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                });
            }
            this.wsSubscriptions = [];
            // create a new client & subscriptions
            const subClient = (0, graphql_ws_1.createClient)({
                url: wsBackend,
                shouldRetry: () => true,
                retryAttempts: Infinity,
                connectionParams: {
                    authorization: 'Bearer ' + auth,
                },
                on: {
                    closed: () => this.logDisconnect(),
                    connected: () => this.logReconnect(),
                },
            });
            this.wsClientSubscribedToWsId = workspaceId;
            this.wsClient = new client_1.ApolloClient({
                link: new subscriptions_1.GraphQLWsLink(subClient),
                cache: new client_1.InMemoryCache({
                    addTypename: false,
                }),
            });
            // ===============================
            // subscribe to shift changes
            // ===============================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.EMP_CALENDAR,
                const_1.PERMISSIONS.BACKOFFICE.ATTENDANCE,
                const_1.PERMISSIONS.BACKOFFICE.TIMEOFFREQUESTS,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
            subscription (
                $workspaceId: ID!
            ) {
                shifts (workspace: $workspaceId) {
                    type
                    obj {
                        ${query_1.default.SHIFT_PARAMS_BASIC}
                        revision {
                            diff
                        }
                    }
                }
            }`,
                    variables: { workspaceId },
                })
                    .subscribe((res) => {
                    const obj = res.data.shifts.obj;
                    // completes the onboarding checklist's „schedule created" step, and its
                    // „published" step too — publishing arrives here as a follow-up update
                    (0, onboarding_signal_1.signalOnboardingRelevantChange)();
                    // shift was deleted on BE -> delete it from store
                    if (obj.archived) {
                        this.setStateCustom((s) => Object.assign({}, s, {
                            batchUpdatesShifts: this.state.batchUpdatesShifts.concat({
                                type: 'deleted',
                                obj,
                            }),
                        }));
                    }
                    else {
                        const { shifts, employees } = store_1.default.getState();
                        const inStoreShift = shifts.find((sf) => sf.id === obj.id);
                        // shift was updated on BE -> update it in store
                        if (inStoreShift) {
                            this.setStateCustom((s) => Object.assign({}, s, {
                                batchUpdatesShifts: this.state.batchUpdatesShifts.concat({
                                    type: 'updated',
                                    obj,
                                }),
                            }));
                        }
                        else {
                            // shift was created on BE -> add it to the store
                            const alreadyBatchedIdx = this.state.batchUpdatesShifts.findIndex((upd) => upd.type === 'created' && upd.obj?.id === obj.id);
                            if (alreadyBatchedIdx === -1) {
                                this.setStateCustom((s) => Object.assign({}, s, {
                                    batchUpdatesShifts: this.state.batchUpdatesShifts.concat({
                                        type: 'created',
                                        obj,
                                    }),
                                }));
                            }
                            else {
                                // a follow-up update (e.g. publish) arrived before the batch was processed — merge it
                                // into the existing queued creation so the shift isn't added to the store with stale data
                                this.setStateCustom((s) => Object.assign({}, s, {
                                    batchUpdatesShifts: this.state.batchUpdatesShifts.map((upd, i) => i === alreadyBatchedIdx
                                        ? {
                                            type: 'created',
                                            obj: Object.assign({}, upd.obj, obj),
                                        }
                                        : upd),
                                }));
                            }
                        }
                        // if shift's userId is a user that's not in store.employees, load the external emps after a few seconds
                        if (obj.userId && !employees[obj.userId]) {
                            this.scheduleBatchReload('external-employees');
                        }
                    }
                }));
            }
            // ===================================
            // subscribe to timeOff changes
            // ===================================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.EMP_CALENDAR,
                const_1.PERMISSIONS.BACKOFFICE.ATTENDANCE,
                const_1.PERMISSIONS.BACKOFFICE.TIMEOFFREQUESTS,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
            subscription (
                $workspaceId: ID!
            ) {
                timeOffs (workspace: $workspaceId) {
                    type
                    obj ${query_1.default.TIME_OFF}
                }
            }`,
                    variables: { workspaceId },
                })
                    .subscribe((res) => {
                    const obj = res.data.timeOffs.obj;
                    const { calendar, workspaces, workspaceId } = store_1.default.getState();
                    const ws = workspaces.find((ws) => ws.id === workspaceId);
                    // event was deleted on BE -> delete it from store
                    if (res.data.timeOffs.type === 'deleted') {
                        this.setStateCustom((s) => Object.assign({}, s, {
                            batchUpdatesTimeOffs: this.state.batchUpdatesTimeOffs.concat({
                                type: 'deleted',
                                obj,
                            }),
                        }));
                    }
                    else {
                        const { timeOffs } = store_1.default.getState();
                        const inStoreEvt = timeOffs.find((sf) => sf.id === obj.id);
                        // event was updated on BE -> update it in store
                        if (inStoreEvt) {
                            this.setStateCustom((s) => Object.assign({}, s, {
                                batchUpdatesTimeOffs: this.state.batchUpdatesTimeOffs.concat({
                                    type: 'updated',
                                    obj,
                                }),
                            }));
                        }
                        else {
                            // event was created on BE -> add it to the store
                            this.setStateCustom((s) => Object.assign({}, s, {
                                batchUpdatesTimeOffs: this.state.batchUpdatesTimeOffs.concat({
                                    type: 'created',
                                    obj,
                                }),
                            }));
                        }
                    }
                    // if *timeOff that's able to generate work time* changed (category.consider is true), reload the calendar.roleStats because the vacation hours & work hours changed for some people
                    const category = ws?.unavailabilityCategories?.find((cat) => cat.id === obj.categoryId);
                    if (category?.consider &&
                        calendar &&
                        calendar.loadedPeriods &&
                        calendar.loadedPeriods.length) {
                        this.scheduleBatchReload('role-stats', [obj.userId]);
                    }
                }));
            }
            // ===================================
            // subscribe to availability changes
            // ===================================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.EMP_CALENDAR,
                const_1.PERMISSIONS.BACKOFFICE.ATTENDANCE,
                const_1.PERMISSIONS.BACKOFFICE.TIMEOFFREQUESTS,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
            subscription (
                $workspaceId: ID!
            ) {
                availabilities (workspace: $workspaceId) {
                    type
                    obj ${query_1.default.AVAILABILITY}
                }
            }`,
                    variables: { workspaceId },
                })
                    .subscribe((res) => {
                    const obj = res.data.availabilities.obj;
                    // event was deleted on BE -> delete it from store
                    if (res.data.availabilities.type === 'deleted') {
                        this.setStateCustom((s) => Object.assign({}, s, {
                            batchUpdatesAvailabilities: this.state.batchUpdatesAvailabilities.concat({
                                type: 'deleted',
                                obj,
                            }),
                        }));
                    }
                    else {
                        const { availabilities } = store_1.default.getState();
                        const inStoreEvt = availabilities.find((sf) => sf.id === obj.id);
                        // event was updated on BE -> update it in store
                        if (inStoreEvt) {
                            this.setStateCustom((s) => Object.assign({}, s, {
                                batchUpdatesAvailabilities: this.state.batchUpdatesAvailabilities.concat({
                                    type: 'updated',
                                    obj,
                                }),
                            }));
                        }
                        else {
                            // event was created on BE -> add it to the store
                            this.setStateCustom((s) => Object.assign({}, s, {
                                batchUpdatesAvailabilities: this.state.batchUpdatesAvailabilities.concat({
                                    type: 'created',
                                    obj,
                                }),
                            }));
                        }
                    }
                }));
            }
            // ===============================
            // subscribe to offer changes
            // ===============================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.EMP_CALENDAR,
                const_1.PERMISSIONS.BACKOFFICE.ATTENDANCE,
                const_1.PERMISSIONS.BACKOFFICE.TIMEOFFREQUESTS,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
            subscription (
                $workspaceId: ID!
            ) {
                offers (workspace: $workspaceId) {
                    type
                    obj ${query_1.default.OFFER}
                }
            }`,
                    variables: { workspaceId },
                })
                    .subscribe((res) => {
                    const obj = res.data.offers.obj;
                    const alreadyInBatch = this.state.batchUpdatesOffers.findIndex((upd) => upd.id === obj.id);
                    if (alreadyInBatch === -1) {
                        // don't store 2 updates for the same offer in batchUpdatesOffers
                        this.setStateCustom((s) => Object.assign({}, s, {
                            batchUpdatesOffers: this.state.batchUpdatesOffers.concat(obj),
                        }));
                    }
                    else {
                        this.setStateCustom((s) => Object.assign({}, s, {
                            batchUpdatesOffers: this.state.batchUpdatesOffers.map((upd) => {
                                if (upd.id === obj.id) {
                                    return Object.assign({}, upd, obj);
                                }
                                else {
                                    return upd;
                                }
                            }),
                        }));
                    }
                }));
            }
            // ===============================
            // subscribe to notifications
            // ===============================
            this.wsSubscriptions.push(this.wsClient
                .subscribe({
                query: (0, client_1.gql) `
            subscription (
                $user: ID!
            ) {
                notifications (user: $user) {
                    type
                    obj ${query_1.default.NOTIFICATION}
                    plus
                }
            }`,
                variables: { user: me.id },
            })
                .subscribe((res) => {
                const newNotification = res.data.notifications.obj;
                const notificationPlus = res.data.notifications?.plus;
                const showNotification = notificationPlus?.find((plus) => plus[0] === 'showToast' && plus[1]) ??
                    null;
                const { notifications } = store_1.default.getState();
                if (notifications.find((n) => n.id === newNotification.id)) {
                    this.props.setNotifications(notifications.map((n) => {
                        if (n.id === newNotification.id) {
                            return Object.assign({}, n, newNotification);
                        }
                        else {
                            return n;
                        }
                    }));
                }
                else {
                    const newNotif = notifications;
                    newNotif.unshift(newNotification);
                    this.props.setNotifications(newNotif);
                    if (showNotification)
                        util_1.notification.classic(newNotification);
                }
            }));
            // ===============================
            // subscribe to (event) warning changes
            // ===============================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.BACKOFFICE.ATTENDANCE,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
              subscription (
                  $workspaceId: ID!
              ) {
                  eventWarnings (workspace: $workspaceId) {
                      type
                      obj {
                        eventId
                        warnings ${query_1.default.EVENT_WARNING}
                      }
                      time
                  }
              }`,
                    variables: { workspaceId },
                })
                    .subscribe((res) => {
                    const obj = res.data.eventWarnings.obj;
                    this.setStateCustom((s) => Object.assign({}, s, {
                        batchUpdatesWarnings: this.state.batchUpdatesWarnings.concat(obj),
                    }));
                }));
            }
            // ===============================
            // subscribe to employee warning changes
            // ===============================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.WORKSPACE.EMPLOYEES,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
              subscription (
                  $workspaceId: ID!
              ) {
                  employeeWarnings (workspace: $workspaceId) {
                      userId
                      warnings ${query_1.default.EMPLOYEE_WARNING}
                  }
              }`,
                    variables: { workspaceId },
                })
                    .subscribe((res) => {
                    const obj = res.data.employeeWarnings;
                    const { employees, calendarFilters } = store_1.default.getState();
                    const hiddenWarnings = calendarFilters.find((fil) => fil.hideWarnings) || { hideWarnings: [] };
                    const inStoreEmp = employees[obj.userId];
                    if (inStoreEmp && !inStoreEmp.employeeWarnings) {
                        inStoreEmp.employeeWarnings = [];
                    }
                    if (inStoreEmp &&
                        misc_1.default.safeStringify(inStoreEmp.employeeWarnings) !==
                            misc_1.default.safeStringify(obj.warnings)) {
                        const newEmps = Object.assign({}, employees);
                        const allUnhiddenWarnings = obj.warnings.filter((ew) => !hiddenWarnings?.hideWarnings?.includes(ew.type));
                        if (newEmps[inStoreEmp.id]) {
                            newEmps[inStoreEmp.id] = Object.assign({}, newEmps[inStoreEmp.id], { employeeWarnings: allUnhiddenWarnings });
                        }
                        this.props.setEmployees(newEmps);
                    }
                }));
            }
            // ===============================
            // subscribe to plans changes
            // ===============================
            if (util_1.permissionsUtil.canRead(const_1.PERMISSIONS.CALENDAR)) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
              subscription (
                  $workspaceId: ID!
              ) {
                  plans (workspace: $workspaceId) {
                      type
                      obj ${query_1.default.PLAN}
                  }
              }`,
                    variables: { workspaceId },
                })
                    .subscribe(async (res) => {
                    const obj = res.data.plans.obj;
                    if (obj?.status) {
                        const { workspaces } = store_1.default.getState();
                        // update the currentPlan prop in currently selected WS
                        this.props.setWorkspaces(workspaces.map((ws) => {
                            if (ws.id === workspaceId) {
                                const newWs = Object.assign({}, ws);
                                newWs.currentPlan = obj;
                                return newWs;
                            }
                            else {
                                return ws;
                            }
                        }));
                        // multiselect just-planned shifts when planning finishes
                        if (obj.status === 'done' && obj.selectedShifts?.length) {
                            let { shifts } = store_1.default.getState();
                            if (obj.selectedShifts.some((ss) => !shifts.some((s) => s.id === ss.id)) &&
                                obj.days?.length) {
                                // if the shifts aren't loaded (for example when we're not currently on calendar page) load them before multiselecting them
                                await this.props.setCalendar({
                                    date: (0, moment_1.default)(obj.days[0].day, 'YYYY-MM-DD').startOf('day'),
                                });
                            }
                            shifts = store_1.default.getState().shifts;
                            await this.props.setCalendarMultiSelect({
                                action: null,
                                sourceEvents: shifts.filter((s) => obj.selectedShifts.includes(s.id)),
                                targets: [],
                                isSelectingTargets: false,
                            });
                            // make sure the auto-planner panel is open on the manager calendar page, when the planning just finished (sometimes it was closed, probably due to some race condition)
                            setTimeout(() => {
                                if (window.location.pathname.includes('/schedule')) {
                                    const { managerAssistant } = store_1.default.getState();
                                    if (!managerAssistant.planningOpen) {
                                        this.props.openPlanning();
                                    }
                                }
                            }, 250);
                        }
                    }
                }));
            }
            // ===============================
            // subscribe to web version updates
            // ===============================
            this.wsSubscriptions.push(this.wsClient
                .subscribe({
                query: (0, client_1.gql) `
              subscription {
                frontendUpdate(type: "web") {
                  type
                  version
                  commit
                  time
                }
              }
            `,
                variables: {},
            })
                .subscribe((res) => {
                const obj = res.data.frontendUpdate;
                console.log('New FE version was released:', obj);
                util_1.notification.release();
            }));
            // ===============================
            // subscribe to roles updates
            // ===============================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.WORKSPACE,
                const_1.PERMISSIONS.BACKOFFICE,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
            subscription {
                roles (workspace: "${workspaceId}") {
                  type
                  obj {
                    hidden
                    terminateDate
                    group
                    customData {
                      firstName
                      lastName
                      telephone
                      employeeId
                      kmToWork
                    }
                    cycleId
                    cycleGroup
                    contract:contractNew ${query_1.default.CONTRACT}
                    contracts {
                      id
                      type
                      period {
                        start
                        end
                      }
                      options
                      contractId
                      positions {
                        ${query_1.default.POSITION_ASSIGNMENT}
                      }
                    }
                    employeeId
                    calendarOrder
                    terminalPIN

                    user {
                      id
                      email
                      firstName
                      lastName
                      telephone
                      name
                      dummy
                      lastActivity
                      lastMobileAppUse
                      mfa {
                        enabled
                      }
                    }
                  }
                }
            }`,
                    variables: {},
                })
                    .subscribe((res) => {
                    const { workspaces, employees } = store_1.default.getState();
                    const updateType = res.data.roles.type;
                    const r = res.data.roles.obj;
                    // a role IS a membership, and it carries the contracts — so this completes
                    // both the checklist's „first employees" and „contracts" steps
                    (0, onboarding_signal_1.signalOnboardingRelevantChange)();
                    if (!workspaces || !r?.user?.id)
                        return false;
                    const originalWS = workspaces.find((w) => w.id === workspaceId);
                    const enforcedLocality = originalWS
                        ? misc_1.default.getEnforcedLocality(originalWS)
                        : false;
                    if (updateType === 'updated' || updateType === 'created') {
                        const newEmpStoreObject = misc_1.default.getEmployeeObjectForStore(r.user, r);
                        const originalEmpInStore = Object.keys(employees).includes(r.user.id)
                            ? employees[r.user.id]
                            : null;
                        // if employee was just marked as hidden, we add 'hidden' to newEmpStoreObject, so this employee is
                        // deleted from our store in the batch processing function
                        if (r.hidden)
                            newEmpStoreObject.hidden = true;
                        const empUpdateType = originalEmpInStore ? 'updated' : 'created';
                        if (!(empUpdateType === 'created' &&
                            enforcedLocality &&
                            !originalWS?.localities.some((l) => l.id === enforcedLocality &&
                                l.assigns.some((ass) => ass.userId === r.user.id)))) {
                            // if I have some 'enforcedLocality', skip creation of employees on different localities
                            if ((empUpdateType === 'updated' &&
                                this._employeeHasChanged(originalEmpInStore, newEmpStoreObject)) ||
                                empUpdateType === 'created') {
                                const roleUpdate = {
                                    type: empUpdateType,
                                    obj: newEmpStoreObject,
                                };
                                // pass the roleUpdate to this.state.batchUpdatesEmployees so they're applied
                                // to store in batch to prevent too many unnecessary rerenders
                                this._addEmployeeUpdateToBatch(roleUpdate);
                            }
                        }
                    }
                }));
            }
            // ===============================
            // subscribe to users updates
            // ===============================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.WORKSPACE.EMPLOYEES,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
            subscription {
                users (workspace: "${workspaceId}") {
                  obj {
                    id
                    email
                    firstName
                    lastName
                    telephone
                    name
                    dummy
                  }
                }
            }`,
                    variables: {},
                })
                    .subscribe((res) => {
                    const { employees } = store_1.default.getState();
                    const u = res.data.users.obj;
                    if (!Object.keys(employees).includes(u?.id))
                        return false;
                    const originalEmpInStore = Object.assign({}, employees[u.id]);
                    const updatedEmpInStore = Object.assign({}, originalEmpInStore, u);
                    if (this._employeeHasChanged(originalEmpInStore, updatedEmpInStore)) {
                        const updateObject = { id: updatedEmpInStore.id };
                        for (const key in updatedEmpInStore) {
                            if (!Object.keys(originalEmpInStore).includes(key) ||
                                originalEmpInStore[key] !== updatedEmpInStore[key]) {
                                updateObject[key] = updatedEmpInStore[key];
                            }
                        }
                        this._addEmployeeUpdateToBatch({
                            type: 'updated',
                            obj: updateObject,
                        });
                    }
                }));
            }
            // ===============================
            // subscribe to changes on workspace, which includes
            // Workspace.localities changes or
            // Workspace.positions cahnges
            // ===============================
            if (util_1.permissionsUtil.canReadOneOf([
                const_1.PERMISSIONS.CALENDAR,
                const_1.PERMISSIONS.WORKSPACE,
                const_1.PERMISSIONS.BACKOFFICE,
                const_1.PERMISSIONS.SETTINGS,
            ])) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
              subscription {
                  workspace (workspace: "${workspaceId}") {
                      obj {
                          id
                          name
                          ${util_1.permissionsUtil.canRead(const_1.PERMISSIONS.WORKSPACE.EMPLOYEES) ? `invites ${query_1.default.INVITE}` : ''}
                          ${util_1.permissionsUtil.canRead(const_1.PERMISSIONS.SETTINGS.SETTINGSOFFERS) ? query_1.default.TRANSFER_GROUPS : ''}

                          positions (archived: false) {
                              id
                              name
                              color
                          }

                          ${query_1.default.WORKSPACE_PARAMS_DETAILS}
                      }
                  }
              }`,
                    variables: { workspaceId },
                })
                    .subscribe(async (res) => {
                    const { workspaces } = store_1.default.getState();
                    let { employees } = store_1.default.getState();
                    const obj = res.data.workspace.obj;
                    // positions and terminals are both embedded in the workspace document, so
                    // creating either one saves it and lands here — that is the checklist's
                    // „job positions" and „terminal" steps. Signalled before the `return`s
                    // below, which only guard this handler's own store bookkeeping.
                    (0, onboarding_signal_1.signalOnboardingRelevantChange)();
                    if (!workspaces || !obj.id)
                        return;
                    const originalWS = workspaces.find((w) => w.id === obj.id);
                    if (!originalWS)
                        return;
                    const memberUpdates = [];
                    // 0) if there is a user creation in the employee update batch, process it here, before we manipulate the
                    // localities or positions, because assignment of localities/positions to users only works if
                    // the store.employees already contains all the users whose localities/positions are being manipulated.
                    // this is required mainly for assignment of position to employee immediately after he's added.
                    if (this.state?.batchUpdatesEmployees?.some((bu) => bu.type === 'created')) {
                        await this.processBatchUpdates();
                        employees = store_1.default.getState().employees;
                    }
                    // 1) if locality assignments changed
                    if (misc_1.default.safeStringify(originalWS.localities) !==
                        misc_1.default.safeStringify(obj.localities)) {
                        // update localities arrays on individual employees: store.employees[...].localities
                        Object.values(employees).forEach((ee) => {
                            const newEmpLocalities = obj.localities
                                .filter((l) => {
                                return !!l.assigns.find((a) => a.userId === ee.id);
                            })
                                .map((l) => l.id);
                            if (misc_1.default.safeStringify(newEmpLocalities) !==
                                misc_1.default.safeStringify(ee.localities)) {
                                memberUpdates.push({
                                    type: 'updated',
                                    obj: { id: ee.id, localities: newEmpLocalities },
                                });
                            }
                        });
                        // update localities array on store: store.workspaces[...].localities
                        this.props.setWorkspaces(workspaces.map((ws) => {
                            if (ws.id === obj.id) {
                                const newWs = Object.assign({}, ws);
                                newWs.localities = [...obj.localities];
                                return newWs;
                            }
                            else {
                                return ws;
                            }
                        }));
                    }
                    // 2) if the workspace's positions changed, reload them.
                    // This subscription has always SELECTED positions (see the query above) and
                    // nothing ever read them, so a position created anywhere other than by the
                    // person looking at the page — the assistant, a colleague, another tab — never
                    // reached store.positions and the table kept showing the old list.
                    //
                    // Reloading rather than patching from `obj`: the store holds the full Position
                    // (positions(archived: true) in request/positions.ts — that argument means
                    // "include archived", and archived ones come back with archived: true while the
                    // rest are null), this payload is three fields of the non-archived ones, so
                    // writing it in would truncate. Hence the filter before comparing.
                    //
                    // Straight away rather than through scheduleBatchReload: _processReloads ticks
                    // every 8.5s, and that much lag while watching the assistant work reads as
                    // broken. loadPositions waits out an in-flight load of its own, so a burst of
                    // creates is still one query.
                    if (positionsFingerprint(store_1.default.getState().positions.filter((p) => p.archived !== true)) !== positionsFingerprint(obj.positions)) {
                        this.props.loadPositions();
                    }
                    // 3) if 'calendarLockedUntil', 'calendarApprovedUntil', 'calendarApprovedOn', 'calendarApprovedBy' or their LVL2/LVL3 variants, or 'userAttributes' changed on the WS update the WS in store
                    const keys = [
                        'calendarLockedUntil',
                        'calendarApprovedUntil',
                        'calendarApprovedOn',
                        'calendarApprovedBy',
                        'calendarApprovedUntilLvl2',
                        'calendarApprovedOnLvl2',
                        'calendarApprovedByLvl2',
                        'calendarApprovedUntilLvl3',
                        'calendarApprovedOnLvl3',
                        'calendarApprovedByLvl3',
                        'userAttributes',
                    ];
                    if (keys.some((key) => {
                        return (misc_1.default.safeStringify(originalWS[key]) !==
                            misc_1.default.safeStringify(obj[key]));
                    })) {
                        this.props.setWorkspaces(workspaces.map((ws) => {
                            if (ws.id === obj.id) {
                                const newWs = Object.assign({}, ws);
                                keys
                                    .filter((key) => {
                                    return (misc_1.default.safeStringify(originalWS[key]) !==
                                        misc_1.default.safeStringify(obj[key]));
                                })
                                    .forEach((key) => {
                                    newWs[key] = obj[key];
                                });
                                return newWs;
                            }
                            else {
                                return ws;
                            }
                        }));
                    }
                    // pass the memberUpdates to this.state.batchUpdatesEmployees so they're applied
                    // to store in batch to prevent too many unnecessary rerenders
                    if (memberUpdates.length) {
                        memberUpdates.forEach((mu) => {
                            this._addEmployeeUpdateToBatch(mu);
                        });
                    }
                }));
            }
            // ===============================
            // subscribe to employees resolving their invites
            // ===============================
            if (util_1.permissionsUtil.canRead(const_1.PERMISSIONS.WORKSPACE.EMPLOYEES)) {
                this.wsSubscriptions.push(this.wsClient
                    .subscribe({
                    query: (0, client_1.gql) `
              subscription {
                  invites (workspace: "${workspaceId}") {
                      obj ${query_1.default.INVITE}
                  }
              }`,
                    variables: {},
                })
                    .subscribe((res) => {
                    const obj = res.data.invites.obj;
                    // if someone resolved their invite (accepted), reload the invites (workspace) and employees list
                    if (obj.resolved) {
                        this.props.loadWorkspaceDetail(workspaceId, true).then(() => {
                            this.props
                                .loadEmployees({
                                excludeExistingEmployee: obj.mergeWith || undefined,
                            })
                                .then(() => {
                                this.props.loadPositions();
                            });
                        });
                    }
                    else {
                        // if this invite is not yet in WS.invites array, add it there
                        const { workspaces, workspaceId } = store_1.default.getState();
                        const ws = workspaces.find((ws) => ws.id === workspaceId);
                        if (Array.isArray(ws?.invites) &&
                            !ws.invites.some((inv) => inv.id === obj.id)) {
                            this.props.setWorkspaces(workspaces.map((ws) => {
                                if (ws.id === workspaceId) {
                                    const newWs = Object.assign({}, ws);
                                    newWs.invites.push(obj);
                                    return newWs;
                                }
                                else {
                                    return ws;
                                }
                            }));
                            // and set corresponding user's 'invited' prop to this invite's ID
                            if (obj.mergeWith) {
                                this._addEmployeeUpdateToBatch({
                                    type: 'updated',
                                    obj: {
                                        id: obj.mergeWith,
                                        invited: obj.id,
                                    },
                                });
                            }
                        }
                    }
                }));
            }
        }
    }
    _destructSubscriptions() {
        this.wsSubscriptions.forEach((subscription) => subscription.unsubscribe());
        this.wsSubscriptions = [];
        this.wsClient?.stop();
        this.wsClient = undefined;
    }
    componentDidUpdate(nextProps, _nextState) {
        // reinitialize the subscriptions if needed
        if (!this.wsClient || // needed if we're not subscribed yet
            (nextProps.workspaceId && nextProps.workspaceId !== this.props.workspaceId) || // if WS changed
            (nextProps.organizationId &&
                nextProps.organizationId !== this.props.organizationId) || // if organization changed
            nextProps.me.id !== this.props.me.id // if user changed
        ) {
            this.destructSubscriptions();
            this.initSubscriptions();
        }
    }
    componentWillUnmount() {
        clearInterval(this.state.processUpdatesInterval);
        clearInterval(this.state.processReloadsInterval);
        clearInterval(this.state.processDisconnectsInterval);
        this.destructSubscriptions();
    }
    componentDidMount() {
        if (misc_1.default.isDayswapsProInterface())
            return; // don't subscribe when we're just now opened DS PRO
        // subscribe to WSS updates
        this.initSubscriptions();
    }
    render() {
        return null;
    }
}
exports.default = (0, connect_1.default)(Websockets);
